import { motion } from "framer-motion";
import { useEffect, useState, useMemo } from "react";
import axios from "axios";
import confetti from "canvas-confetti";
import { apiurl } from "../config/config";
import { Link, useSearchParams } from "react-router-dom";
import { MANAGERS } from "../json/salesTarget";


/* ================= COLOR PER 10% ================= */
const getColor = (p) => {
  if (p >= 100) return "#16a34a";
  if (p >= 90) return "#22c55e";
  if (p >= 80) return "#4ade80";
  if (p >= 70) return "#a3e635";
  if (p >= 60) return "#facc15";
  if (p >= 50) return "#fbbf24";
  if (p >= 40) return "#fb923c";
  if (p >= 30) return "#f97316";
  if (p >= 20) return "#ef4444";
  return "#dc2626";
};

/* ================= MAIN ================= */
export default function ManagerDisplay() {
    const [toggleCount, setToggleCount] = useState(0);

  const [searchParams] = useSearchParams();
  const paramA = searchParams.get("A");
  const paramB = searchParams.get("B");

  const managerA = useMemo(
    () => MANAGERS.find((m) => m.key === paramA) || MANAGERS[0],
    [paramA]
  );
  const managerB = useMemo(
    () => MANAGERS.find((m) => m.key === paramB) || MANAGERS[1],
    [paramB]
  );

  const [orders, setOrders] = useState({ A: 0, B: 0 });
  const [loading, setLoading] = useState(true);
  const [openPicker, setOpenPicker] = useState(false);

  /* ================= FETCH (30s) ================= */
  useEffect(() => {
    const fetchSales = async () => {
      try {
        const res = await axios.get(`${apiurl}/utils/crm/realTimeOrderData`, {
          headers: {
            token: "ad2355a9d54335e27e2c3a3ed5b6e381",
            "Content-Type": "application/json",
          },
          params: {
            from_date: "2026-01-27",
            to_date: "2026-01-27",
          },
        });

        const list = res?.data?.data?.result?.data?.managers || [];

        const a = list.find((m) => m.o_manager_name === managerA.key);
        const b = list.find((m) => m.o_manager_name === managerB.key);

        setOrders({
          A: Number(a?.totalOrders || 0),
          B: Number(b?.totalOrders || 0),
        });
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };

    fetchSales();
    const t = setInterval(fetchSales, 30000);
    return () => clearInterval(t);
  }, [managerA.key, managerB.key]);

  /* ================= AUTO ROTATE (60s) ================= */
//   useEffect(() => {
//     const rotate = setInterval(() => {
//       const i = MANAGERS.findIndex((m) => m.key === managerA.key);
//       const next = (i + 1) % MANAGERS.length;
//       window.location.href = `/screen/manager-display?A=${MANAGERS[i].key}&B=${MANAGERS[next].key}`;
//     }, 60000);

//     return () => clearInterval(rotate);
//   }, [managerA.key]);

  /* ================= CONFETTI ================= */
  useEffect(() => {
    if (!loading) {
      confetti({ particleCount: 100, spread: 80, origin: { y: 0.6 } });
    }
  }, [orders, loading]);

  const achA = Math.round((orders.A / managerA.target) * 100);
  const achB = Math.round((orders.B / managerB.target) * 100);

  const winner =
    orders.A === orders.B ? "DRAW" : orders.A > orders.B ? "A" : "B";

  const leadText =
    winner === "DRAW"
      ? "Draw match"
      : winner === "A"
      ? `${managerA.name} leads by ${orders.A - orders.B} orders`
      : `${managerB.name} leads by ${orders.B - orders.A} orders`;



// const navigate = useNavigate();
// useEffect(() => {
//   const A = searchParams.get("A");
//   const B = searchParams.get("B");

//   const timer = setTimeout(() => {
//     setToggleCount((c) => c + 1);

//     if (A === "ASHWANI3434" && B === "Himanshu1203") {
//       navigate(
//         "/screen/manager-display?A=SanjayRewani1619&B=Abhishek4629",
//         { replace: true }
//       );
//     } else {
//       navigate(
//         "/screen/manager-display?A=ASHWANI3434&B=Himanshu1203",
//         { replace: true }
//       );
//     }
//   }, 15000);

//   return () => clearTimeout(timer);
// }, [searchParams, navigate]);

// useEffect(() => {
//   if (toggleCount >= 4) {
//     navigate("/screen/floors-display", { replace: true });
//   }
// }, [toggleCount, navigate]);


  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center text-4xl font-bold">
        Loading…
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      {/* HEADER */}
      <div className="mb-10">
        {/* Top Row */}
        <div className="flex justify-between items-center mb-6 md:hidden">
          <h1 className="hidden md:block text-2xl md:text-5xl font-extrabold">
            Manager Performance Battle
          </h1>

          <Link
            className="text-white bg-black px-4 py-2 rounded-lg md:hidden"
            to="/screen/floors-display"
          >
            Back
          </Link>
          <button
            onClick={() => setOpenPicker(true)}
            className="bg-black text-white px-6 py-2 rounded-xl text-lg hover:scale-105 transition"
          >
            Change Managers
          </button>
        </div>

        {/* Battle Row */}
        <div className="grid grid-cols-1 md:grid-cols-[1fr_auto_1fr] items-center gap-6">
          {/* Manager A */}
          <div className="text-right hidden md:block">
            <p className="text-sm uppercase tracking-widest text-gray-500">
              Manager A
            </p>
            <h2 className="text-3xl font-extrabold">{managerA.name}</h2>
          </div>

          {/* Live Lead Banner */}
          <div className="flex justify-center">
            <LiveLeadBanner
              text={leadText}
              winner={winner}
              diff={Math.abs(orders.A - orders.B)}
            />
          </div>

          {/* Manager B */}
          <div className="text-left hidden md:block">
            <p className="text-sm uppercase tracking-widest text-gray-500">
              Manager B
            </p>
            <h2 className="text-3xl font-extrabold">{managerB.name}</h2>
          </div>
        </div>
      </div>

      {/* CARDS */}
      {/* <div className="grid grid-cols-2 md:grid-cols-[45%_10%_45%] items-center"> */}
      <div className="grid grid-cols-2 md:grid-cols-[40%_20%_40%] items-center gap-1 w-full mx-auto">
        <ManagerCard
          manager={managerA}
          value={orders.A}
          achievement={achA}
          status={winner === "DRAW" ? "DRAW" : winner === "A" ? "WIN" : "LOSE"}
        />

        <div className="text-center text-[8rem] font-extrabold text-gray-300 hidden md:block">
          VS
        </div>

        <ManagerCard
          manager={managerB}
          value={orders.B}
          achievement={achB}
          status={winner === "DRAW" ? "DRAW" : winner === "B" ? "WIN" : "LOSE"}
        />
      </div>

      {/* PICKER */}
      {openPicker && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
          <div className="bg-white rounded-3xl p-8 w-[420px]">
            <h2 className="text-3xl font-bold mb-6 text-center">
              Choose Managers
            </h2>

            <select id="A" className="w-full border p-3 mb-4 rounded-xl">
              {MANAGERS.map((m) => (
                <option key={m.key} value={m.key}>
                  {m.name}
                </option>
              ))}
            </select>

            <select id="B" className="w-full border p-3 mb-6 rounded-xl">
              {MANAGERS.map((m) => (
                <option key={m.key} value={m.key}>
                  {m.name}
                </option>
              ))}
            </select>

            <button
              onClick={() => {
                const A = document.getElementById("A").value;
                const B = document.getElementById("B").value;
                window.location.href = `/screen/manager-display?A=${A}&B=${B}`;
              }}
              className="w-full bg-green-600 text-white py-3 rounded-xl text-lg font-semibold"
            >
              Start Battle 🚀
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

/* ================= CARD ================= */
function ManagerCard({ manager, value, achievement, status }) {
  const color = getColor(achievement);

  return (
    <motion.div
      animate={{ scale: status === "WIN" ? [1, 1.05, 1] : 1 }}
      transition={{ duration: 1, repeat: status === "WIN" ? Infinity : 0 }}
      className="relative bg-white rounded-3xl shadow-2xl p-6"
    >
      {/* STATUS STRIP */}
      {status !== "DRAW" && (
        <div
          className={`absolute top-0 left-0 right-0 text-center py-2 text-white font-bold rounded-t-3xl ${
            status === "WIN" ? "bg-green-600" : "bg-red-600"
          }`}
        >
          {status === "WIN" ? "🏆 WINNER" : "😞 LOSER"}
        </div>
      )}

      {status === "DRAW" && (
        <div className="absolute top-0 left-0 right-0 text-center py-2 bg-gray-700 text-white font-bold rounded-t-3xl">
          🤝 DRAW
        </div>
      )}

      <div className="flex flex-col items-center gap-4 mt-6">
        <img
          src={manager.photo}
          className="w-48 h-48 md:w-80 md:h-80 rounded-full border-4 object-cover"
          style={{ borderColor: color }}
        />
        <h2 className="text-3xl font-bold">{manager.name}</h2>
      </div>

      {/* NUMBERS */}
      <div className="mt-6 text-center">
        <div className="text-2xl md:text-5xl font-extrabold">
          {value} / {manager.target}
        </div>
        <p className="text-xl text-gray-600 mt-1">{achievement}% achieved</p>
      </div>

      {/* BAR */}
      <div className="mt-6 h-5 bg-gray-200 rounded-full overflow-hidden">
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: `${Math.min(achievement, 100)}%` }}
          transition={{ duration: 0.6 }}
          className="h-full"
          style={{ background: color }}
        />
      </div>
    </motion.div>
  );
}

function LiveLeadBanner({ text, winner, diff }) {
  if (winner === "DRAW") {
    return (
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="mt-4 bg-gray-800 text-white px-6 py-3 rounded-2xl inline-flex items-center gap-3 text-xl font-bold"
      >
        🤝 DRAW MATCH
      </motion.div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="relative mt-4 overflow-hidden rounded-2xl px-8 py-4 inline-flex items-center gap-4
                 bg-gradient-to-r from-yellow-400 via-orange-500 to-red-500 text-white shadow-2xl"
    >
      {/* Shine Sweep */}
      <motion.div
        className="absolute inset-0 bg-white/20"
        initial={{ x: "-100%" }}
        animate={{ x: "200%" }}
        transition={{ repeat: Infinity, duration: 2, ease: "linear" }}
      />

      {/* Trophy Pulse */}
      <motion.span
        animate={{ scale: [1, 1.3, 1] }}
        transition={{ repeat: Infinity, duration: 1.5 }}
        className="text-3xl"
      >
        🏆
      </motion.span>

      {/* Text */}
      <span className="relative z-10 text-xl md:text-2xl font-extrabold tracking-wide">
        {text}
      </span>

      {/* Live Badge */}
      <motion.span
        animate={{ opacity: [1, 0.4, 1] }}
        transition={{ repeat: Infinity, duration: 1 }}
        className="ml-3 bg-black/40 px-3 py-1 rounded-full text-sm font-bold"
      >
        LIVE
      </motion.span>

      {/* Lead Count Bounce */}
      <motion.span
        key={diff}
        initial={{ scale: 1.6 }}
        animate={{ scale: 1 }}
        transition={{ type: "spring", stiffness: 300 }}
        className="ml-2 text-2xl font-black"
      >
        +{diff}
      </motion.span>
    </motion.div>
  );
}